import React, { useEffect, useState } from 'react';
import { useReactiveScripts } from '@/hooks/useReactiveSettings';

const ScriptsInjector: React.FC = () => {
  const scripts = useReactiveScripts();
  const [injectedVersion, setInjectedVersion] = useState(0);

  useEffect(() => {
    // Удаляем старые инжектированные элементы
    const oldElements = document.querySelectorAll('[data-admin-injected]');
    oldElements.forEach(el => el.remove());

    const injectHTML = (html: string) => {
      if (!html.trim()) return;
      
      // Создаём временный контейнер для парсинга HTML
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // Обрабатываем каждый элемент
      Array.from(temp.children).forEach((child) => {
        if (child.tagName === 'SCRIPT') {
          const script = document.createElement('script');
          
          // Копируем атрибуты
          Array.from(child.attributes).forEach((attr) => {
            script.setAttribute(attr.name, attr.value);
          });
          
          // Копируем содержимое
          if (child.textContent) {
            script.textContent = child.textContent;
          }
          
          // Маркируем как инжектированный
          script.setAttribute('data-admin-injected', 'true');
          document.head.appendChild(script);
        } else {
          // Для других элементов (meta, link и т.д.)
          const clone = child.cloneNode(true) as Element;
          clone.setAttribute('data-admin-injected', 'true');
          document.head.appendChild(clone);
        }
      });
    };

    // Инжектим все скрипты
    if (scripts.googleAnalyticsCode) {
      injectHTML(scripts.googleAnalyticsCode);
    }

    if (scripts.googleAdsenseCode) {
      injectHTML(scripts.googleAdsenseCode);
    }

    if (scripts.customHeadCode) {
      injectHTML(scripts.customHeadCode);
    }

    setInjectedVersion(v => v + 1);
  }, [scripts]);

  return null;
};

export default ScriptsInjector;
